export default [
	{
		path: "/pros/class-schedule",
		exact: true,
		policy: "providerAuth",
		component: "ClassSchedule",
		mui: true,
	},
];
